import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'appointmentDateFormat' })
export class AppointmentDateFormatPipe implements PipeTransform {
  transform(dateString: string): string {
    if (!dateString) return '';
    const date = new Date(dateString);
    const dayOfWeek = date.toLocaleDateString('en-US', { weekday: 'long' });
    const formattedDate = date.toLocaleDateString('en-US', {
      month: '2-digit',
      day: '2-digit',
      year: 'numeric',
    });
    return `${dayOfWeek}, ${formattedDate}`;
  }
}
